import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import api from "../../api/config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ProviderCardBody = ({ item, fetchProviderListing }) => {
  const navigate = useNavigate();

  const deleteProviderItem = async (e, id) => {
    e.preventDefault();
    try {
      const response = await api.post(`/space-feed-delete/${id}`);
      if (response?.data?.status === 200) {
        toast.success("Property Deleted Successfully");
        fetchProviderListing();
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const editProviderItem = (e, id) => {
    e.preventDefault();
    navigate(`/provider-business/${id}`);
  };

  return (
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="card-title text-body mt-4">{item?.name}</h5>
        <div>
          <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
            <FontAwesomeIcon
              onClick={(e) => editProviderItem(e, item?.spaceFeedId)}
              style={{ cursor: "pointer" }}
              icon={faPenToSquare}
              color="black"
              className="mt-4"
            />
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
            <FontAwesomeIcon
              onClick={(e) => deleteProviderItem(e, item?.spaceFeedId)}
              icon={faTrash}
              color="black"
              className="mt-4"
              style={{ marginLeft: "1rem", cursor: "pointer" }}
            />
          </OverlayTrigger>
        </div>
      </div>
      <span className="text-black-50 mt-1">
        {item?.address1
          ?.replace(/USA/i, "")
          ?.replace(/United States/i, "")
          ?.replace(/New York/i, "")
          .replace(/,\s*$/, "")}
      </span>
      <br />
      <span className="text-black-50">
        {/* {item?.city}, {item?.state} {item?.pin && item?.pin} */}
      </span>
    </div>
  );
};

export default ProviderCardBody;
